import React, { useEffect, useRef, useState } from "react";
import { SCRIPTURES } from "../../data/mock";
import { BookOpen, ChevronLeft, ChevronRight } from "lucide-react";
import { IMAGES } from "../../data/mock";

export default function ScriptureBanner() {
  const [i, setI] = useState(0);
  const [auto, setAuto] = useState(true);
  const timer = useRef(null);

  useEffect(() => {
    if (!auto) return;
    timer.current = setInterval(() => setI((v) => (v + 1) % SCRIPTURES.length), 5500);
    return () => clearInterval(timer.current);
  }, [auto]);

  const go = (dir) => {
    setAuto(false);
    setI((v) => (v + dir + SCRIPTURES.length) % SCRIPTURES.length);
  };

  const s = SCRIPTURES[i];

  return (
    <section id="scripture" className="relative overflow-hidden border-b hairline">
      {/* Background bible image (very dark) */}
      <div className="absolute inset-0">
        <img src={IMAGES.bible} alt="" className="w-full h-full object-cover opacity-[0.22]" />
        <div className="absolute inset-0" style={{ background: "radial-gradient(1200px 500px at 50% 50%, rgba(201,114,42,0.14), transparent 60%), linear-gradient(180deg, rgba(10,9,8,0.9) 0%, rgba(10,9,8,0.85) 50%, rgba(10,9,8,0.95) 100%)" }}></div>
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="flex items-center justify-between gap-6 mb-10">
          <div className="flex items-center gap-3">
            <BookOpen size={16} className="text-[var(--ember-2)]" />
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)]">The Word for Men</span>
            <span className="h-px w-16 bg-[var(--line-2)] hidden md:block"></span>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--text-muted)] hidden md:block">King James Version</span>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={() => go(-1)} className="w-10 h-10 border hairline-2 flex items-center justify-center hover:border-[var(--ember-2)] hover:text-[var(--ember-2)] transition-colors" aria-label="Previous verse"><ChevronLeft size={16}/></button>
            <button onClick={() => go(1)} className="w-10 h-10 border hairline-2 flex items-center justify-center hover:border-[var(--ember-2)] hover:text-[var(--ember-2)] transition-colors" aria-label="Next verse"><ChevronRight size={16}/></button>
          </div>
        </div>

        {/* Current verse */}
        <div key={i} className="grid md:grid-cols-[auto_1fr] gap-6 md:gap-14 items-start animate-[fadeUp_1s_ease_forwards]">
          <div className="font-display text-[110px] md:text-[220px] leading-[0.75] text-[var(--ember-2)] opacity-70 select-none">“</div>
          <div className="pt-3 md:pt-10">
            <div className="font-mono text-[10px] uppercase tracking-[0.34em] text-[var(--ember-3)]">{s.theme}</div>
            <blockquote className="mt-6 font-display italic font-light text-[34px] md:text-[68px] leading-[1.06] tracking-[-0.02em] max-w-[1050px]">
              {s.text}
            </blockquote>
            <div className="mt-8 flex items-center gap-4">
              <span className="h-px w-10 bg-[var(--ember-2)]"></span>
              <span className="font-mono text-[12px] uppercase tracking-[0.3em] text-[var(--text-muted)]">{s.ref}</span>
            </div>
          </div>
        </div>

        {/* Verse index rail */}
        <div className="mt-16 md:mt-20 border-t hairline pt-8">
          <div className="grid grid-cols-5 md:grid-cols-10 gap-2">
            {SCRIPTURES.map((v, idx) => (
              <button key={idx} onClick={() => { setAuto(false); setI(idx); }} className="group text-left">
                <div className={`h-[3px] w-full transition-all duration-700 ${idx === i ? "bg-[var(--ember-2)]" : "bg-[var(--line-2)] group-hover:bg-[var(--iron)]"}`}></div>
                <div className={`mt-3 font-mono text-[10px] uppercase tracking-[0.22em] transition-colors ${idx === i ? "text-[var(--ember-3)]" : "text-[var(--text-dim)] group-hover:text-[var(--text-muted)]"}`}>{String(idx+1).padStart(2,"0")}</div>
                <div className={`hidden md:block mt-2 text-[11px] leading-tight transition-colors ${idx === i ? "text-[var(--text)]" : "text-[var(--text-muted)] group-hover:text-[var(--text)]"}`}>{v.ref}</div>
              </button>
            ))}
          </div>
        </div>
      </div>

      <style>{`@keyframes fadeUp { 0% { opacity: 0; transform: translateY(18px);} 100% { opacity: 1; transform: none;} }`}</style>
    </section>
  );
}
